import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { MdClear } from 'react-icons/md';

import { Equipment } from '@app/api/models';
import { booleanBodyRender } from '@app/components/common/table/body-renders/bool';

import { TableColumn } from '../common/table/types';

export const useColumns: (canClear: boolean, onQrClear: (id: string) => void) => TableColumn<Equipment>[] = (canClear, onQrClear) => [
  {
    name: 'id',
    label: '#',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'type',
    label: 'Тип', 
    options: {
      filter: {
        name: 'type_id',
        sourceName: 'equipment_type',
        type: 'multi-select',
      },
      sort: true,
      customBodyRender: (value: EntityBase | null) => (
        <span>{value?.name || '-'}</span>
      ),
    },
  },
  {
    name: 'model',
    label: 'Модель',
    options: {
      filter: {
        name: 'model_id',
        sourceName: 'equipment_model',
        type: 'multi-select',
      },
      sort: true,
      customBodyRender: (value: EntityBase | null) => (
        <span>{value?.name || '-'}</span>
      ),
    },
  },
  {
    name: 'brand',
    label: 'Бренд',
    options: {
      filter: {
        name: 'brand_id',
        sourceName: 'equipment_brand',
        type: 'multi-select',
      },
      sort: true,
      customBodyRender: (value: EntityBase | null) => (
        <span>{value?.name || '-'}</span>
      ),
    },
  },
  {
    name: 'manufacturer',
    label: 'Производитель',
    options: {
      filter: {
        name: 'manufacturer_id',
        sourceName: 'equipment_manufacturer',
        type: 'multi-select',
      },
      sort: true,
      customBodyRender: (value: EntityBase | null) => (
        <span>{value?.name || '-'}</span>
      ),
    },
  },
  {
    name: 'status_erp',
    label: 'Статус ЕРП',
    options: {
      filter: {
        name: 'status_erp_id',
        sourceName: 'equipment_status_erp',
        type: 'multi-select',
      },
      sort: true,
      customBodyRender: (value: EntityBase | null) => (
        <span>{value?.name || '-'}</span>
      ),
    },
  },
  {
    name: 'status_loc',
    label: 'Статус SNEG',
    options: {
      filter: {
        name: 'status_loc_id',
        sourceName: 'equipment_status_loc',
        type: 'multi-select',
      },
      sort: true,
      customBodyRender: (value: EntityBase | null) => (
        <span>{value?.name || '-'}</span>
      ),
    },
  },
  {
    name: 'production_date',
    label: 'Дата производства',
    options: {
      filter: {
        name: 'production_date',
        type: 'date',
        onApply: (value: string) => value + 'T00:00:00',
      },
      sort: true,
    },
  },
  {
    name: 'delivery_date',
    label: 'Дата поставки',
    options: {
      filter: {
        name: 'delivery_date',
        type: 'date',
        onApply: (value: string) => value + 'T00:00:00',
      },
      sort: true,
    },
  },
  {
    name: 'purchase_date',
    label: 'Дата приобретения',
    options: {
      filter: {
        name: 'purchase_date',
        type: 'date',
        onApply: (value: string) => value + 'T00:00:00',
      },
      sort: true,
    },
  },
  {
    name: 'serial_num',
    label: 'Серийный номер',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'inventory_num',
    label: 'Инвентарный номер',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'qrcode',
    label: 'QR-код',
    options: {
      filter: false,
      sort: true,
    },
  },
  ... canClear ? [{
    name: 'id',
    label: 'Отчистить QR-код',
    options: {
      customBodyRender: (id, meta) => {
        if (!meta.rowData.qrcode) {return null;}
        return <IconButton onClick={() => onQrClear(id)} icon={<MdClear />} aria-label="clear-qr" />;
      }
    },
  }] : [],
  {
    name: 'is_imported_qrcode',
    label: 'Импорт QR',
    options: {
      filter: false,
      sort: true,
      customBodyRender: booleanBodyRender(),
    },
  },
  {
    name: 'collateral_value',
    label: 'Залоговая стоимость',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'ingress_protection',
    label: 'Степень защиты',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'is_efficient',
    label: 'Эффективность',
    options: {
      filter: {
        name: 'is_efficient',
        type: 'boolean',
      },
      sort: false,
      customBodyRender: booleanBodyRender(),
    },
  },
  {
    name: 'comment',
    label: 'Комментарий',
    options: {
      filter: false,
      sort: true,
    },
  },
];
